const getRootHeight = offset => {
	return offset
		? document.getElementById('root').offsetHeight + offset
		: document.getElementById('root').offsetHeight
}

export default getRootHeight



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/getRootHeight.js